import { render, staticRenderFns } from "./post.vue?vue&type=template&id=515a7d96"
import script from "./post.vue?vue&type=script&lang=js"
export * from "./post.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('515a7d96')) {
      api.createRecord('515a7d96', component.options)
    } else {
      api.reload('515a7d96', component.options)
    }
    module.hot.accept("./post.vue?vue&type=template&id=515a7d96", function () {
      api.rerender('515a7d96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/storyTab/storyMaker/stiker/post.vue"
export default component.exports